import PropTypes from 'prop-types';
import DefaultTemplate from '../Default/DefaultTemplate';

const ThumbnailsTemplate = (props) => {
  return <DefaultTemplate {...props} showThumbnail />;
};

ThumbnailsTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default ThumbnailsTemplate;
